function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { InMemoryCache } from "@apollo/client";
import dataIdFromObject from "../../shared/apollo/dataIdFromObject";
export default function createCache(schemas) {
    const possibleTypes = schemas.reduce((acc, schema)=>_object_spread({}, acc, schema.possibleTypes), {});
    const anonymousTypes = schemas.flatMap((schema)=>schema.anonymousTypes);
    return new InMemoryCache({
        possibleTypes,
        dataIdFromObject,
        typePolicies: Object.fromEntries(anonymousTypes.map((type)=>[
                type,
                {
                    merge: true
                }
            ]))
    });
}

//# sourceMappingURL=createCache.js.map